//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionLibs from "utils/regionSeatLibs";
import ChangeDialog from "./ChangeDialog";
let regionData = JSON.parse(JSON.stringify(regionLibs[0].c));
export default {
  name: "CooperativeManageList",
  data() {
    return {
      filterForm: {
        provinceId: "",
        cityId: "",
        areaId: "",
        cooperativeName: "",
        directorName: "",
        businessZoneId: "", //业务区域id
        businessPersonId: "", //业务负责人id
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],

      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,

      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      showDialog: false, // 弹窗
      multipleSelection: [], // 多选
    };
  },
  components: { ChangeDialog },
  filters: {},
  watch: {
    checkedRegionData(newVal) {
      this.filterForm.provinceId = newVal[0] || "";
      this.filterForm.cityId = newVal[1] || "";
      this.filterForm.areaId = newVal[2] || "";
    },
    checkedZone(newVal) {
      this.filterForm.businessPersonId = "";
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  created() {
    this.getCooperativeList();
    this.getBusinessZoneData();
  },
  mounted() {},
  methods: {
    /**
     * @description
     * @Author quwandong
     * @Date 2023-10-17 20:29:42
     */
    onSettingBtnClick(row) {
      this.$router.push({
        path: "/cooperative/management/setting",
        query: {
          masterId: row.accountId,
        },
      });
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
    /**
     * @description: 多选
     * @Author: yangsibo
     * @Date: 2022-05-18 14:56:05
     * @param val
     */
    selectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.page = 1;
      this.getCooperativeList();
    },
    //获取列表数据
    getCooperativeList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.cooperative.cooperativeListFilter(params).then((res) => {
        this.tableData = res.data.content;
        if (this.pagination.page == 1)
          this.pagination.total = res.data.recordTotal;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedRegionData = [];
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCooperativeList();
    },
    /**
     * @description: 更改区域或业务员
     * @Author: yangsibo
     * @Date: 2022-05-18 15:27:45
     * @param id
     * @return {*}
     */
    changeAreaOrSalesman() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请先勾选要操作的数据",
          duration: 2000,
        });
        return;
      }
      this.showDialog = true;
    },
    /**
     * @description: 查看合作社
     * @Author: quwandong
     * @Date: 2022-05-18 15:27:45
     * @param row
     */
    lookDetail(row) {
      const routeResolve = this.$router.resolve({
        path: "/cooperative/trustee/contract",
        query: {
          $businessId: row.id,
          $businessName: row.cooperativeName,
          $businessType: "_blank",
          $businessAccountId: row.accountId,
          $backPath: this.$route.path,
        },
      });

      window.open(routeResolve.href, "_blank");
    },
  },
};
